export default __webpack_public_path__ + "static/media/logo-negative.3d188a75.png";